import React from 'react';
import { ChevronDown, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { bakeryInfo } from '../data/mock';
import { images } from '../data/mock';

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="Cafe Konditorei Rieppel"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e1919]/80 via-[#1e1919]/60 to-[#1e1919]/90" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center pt-20 pb-24 sm:pt-0 sm:pb-0">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 sm:px-5 py-2 mb-6 sm:mb-8 animate-fade-in">
          <span className="w-2 h-2 bg-[#fad24b] rounded-full animate-pulse" />
          <span className="text-white/90 text-xs sm:text-sm font-medium">365 Tage im Jahr für Sie da</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          <span className="block">Wiener</span>
          <span className="block text-[#fad24b]">Backtradition</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl md:text-2xl text-white/80 mb-3 sm:mb-4 font-light">
          {bakeryInfo.name}
        </p>
        <p className="text-base sm:text-lg text-white/60 mb-8 sm:mb-10 max-w-2xl mx-auto px-2">
          {bakeryInfo.slogan} – Qualität und Handwerkskunst, 
          die man schmecken kann.
        </p>

        {/* Info Pills */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4 mb-10 sm:mb-12">
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 sm:px-5 py-2.5 sm:py-3">
            <MapPin className="w-4 sm:w-5 h-4 sm:h-5 text-[#fad24b]" />
            <span className="text-white text-xs sm:text-sm">{bakeryInfo.address}</span>
          </div>
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 sm:px-5 py-2.5 sm:py-3">
            <Clock className="w-4 sm:w-5 h-4 sm:h-5 text-[#fad24b] flex-shrink-0" />
            <span className="text-white text-xs sm:text-sm">Mo–Fr 5:30–18:30 · Sa 5:30–14:00 · So 7:00–14:00</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4 sm:px-0">
          <a
            href={`tel:${bakeryInfo.phone}`}
            className="inline-flex items-center justify-center gap-2 bg-[#61525a] text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-full text-base sm:text-lg font-medium transition-all duration-300 hover:bg-[#4a3f45] hover:shadow-2xl hover:-translate-y-1"
          >
            Jetzt anrufen
          </a>
          <Link
            to="/sortiment"
            className="inline-flex items-center justify-center gap-2 bg-[#fad24b] text-[#1e1919] px-6 sm:px-8 py-3.5 sm:py-4 rounded-full text-base sm:text-lg font-medium transition-all duration-300 hover:bg-[#e5c043] hover:shadow-2xl hover:-translate-y-1"
          >
            Unser Sortiment
          </Link>
          <a
            href="#torten"
            className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm border border-white/30 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-full text-base sm:text-lg font-medium transition-all duration-300 hover:bg-white/20"
          >
            Torten Katalog
          </a>
        </div>
      </div>

      {/* Scroll Indicator - Hidden on mobile */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden sm:block">
        <a href="#ueber-uns" className="text-white/60 hover:text-white transition-colors duration-300">
          <ChevronDown className="w-8 h-8" />
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
